<template>
  <article
    class="gh-card gh-card--text"
    :class="{ 'gh-card--collapsed': collapsed }"
  >
    <slot name="context-head" />
    <div class="gh-card-text__header">
      <div class="gh-card-text__header-left">
        <button type="button" class="gh-card__chevron" @click="$emit('toggle-collapse')">
          <i
            :class="collapsed ? 'fa fa-chevron-up' : 'fa fa-chevron-down' "
            aria-hidden="true"
          ></i>
        </button>
        <span
          class="gh-card-text__title"
          :class="{ 'gh-dnd-source': canDrag && posterUrl && outputBody }"
          :draggable="canDrag && !!posterUrl && !!outputBody"
          @dragstart="onConceptTextDragStart"
          @dragend="onDragEnd"
        >{{ cardTitle }}</span>
      </div>
      <GenerationHistoryDesignCardActions
        :is-favorite="card.is_favorite"
        :is-copied="isCopied"
        :is-image-copied="isImageCopied"
        :show-copy-image="!!posterUrl"
        :show-copy="true"
        :show-copy-prompt="false"
        @copy="$emit('copy')"
        @copy-image="$emit('copy-image', $refs.posterImage)"
        @download="$emit('download')"
        @favorite="$emit('favorite')"
      />
    </div>
    <GenerationHistoryCardSlide :expanded="!collapsed">
      <div class="gh-card-text__body">
        <div
          class="gh-card-text__output"
          :class="{ 'gh-card-text__output--with-poster': !!posterUrl }"
        >
          <div v-if="posterUrl" class="gh-card-text__output-images-wrap">
            <div class="gh-card-text__output-images">
              <img
                ref="posterImage"
                :src="posterUrl"
                class="gh-card-text__output-image gh-card-text__output-image--single"
                :class="{ 'gh-dnd-source': canDrag }"
                alt=""
                :draggable="canDrag"
                @dragstart="onPosterDragStart($event, posterUrl, posterIndex)"
                @dragend="onDragEnd"
              >
            </div>
            <div
              v-if="outputBody"
              class="gh-card-text__output-text gh-card-text__field-value--output"
              :class="{ 'gh-dnd-source': canDrag && outputBody }"
              :draggable="canDrag && !!outputBody"
              @dragstart="onConceptTextDragStart"
              @dragend="onDragEnd"
            >
              <GenerationHistoryPromptPopover
                :text="outputBody"
                tooltip
              />
            </div>
          </div>
          <p
            v-else
            class="gh-card__text"
            :class="{ 'gh-dnd-source': canDrag && outputBody }"
            :draggable="canDrag && !!outputBody"
            @dragstart="onConceptTextDragStart"
            @dragend="onDragEnd"
          >{{ outputBody }}</p>
        </div>
        <div class="gh-card-text__meta">
          <GenerationHistoryMetaRows
            :fields="metaFields"
            variant="detail"
            :row-key-prefix="`concept-${card.item_id}-${posterIndex}`"
          />
        </div>
      </div>
    </GenerationHistoryCardSlide>
  </article>
</template>

<script>
import {
  getCardOutputBody,
  getCardTitle,
  getConceptCardImageUrls,
  getConceptCardPosterIndex,
  getDetailBodyMetaFields,
} from '@/shared/helpers/generationHistory';
import { GH_DRAG_SOURCE } from '@/shared/helpers/generationHistoryDrag';
import { generationHistoryCardDragMixin } from '@/shared/mixins/generationHistoryDragDropMixin';
import GenerationHistoryCardSlide from '../shared/GenerationHistoryCardSlide.vue';
import GenerationHistoryDesignCardActions from '../shared/GenerationHistoryDesignCardActions.vue';
import GenerationHistoryMetaRows from '../shared/GenerationHistoryMetaRows.vue';
import GenerationHistoryPromptPopover from '../shared/GenerationHistoryPromptPopover.vue';

export default {
  name: 'GenerationHistoryDetailCardConcept',
  mixins: [generationHistoryCardDragMixin],
  components: {
    GenerationHistoryCardSlide,
    GenerationHistoryDesignCardActions,
    GenerationHistoryMetaRows,
    GenerationHistoryPromptPopover,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    projectType: {
      type: Number,
      required: true,
    },
    cardIndex: {
      type: Number,
      default: 0,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    isCopied: {
      type: Boolean,
      default: false,
    },
    isImageCopied: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardTitle() {
      return getCardTitle(this.card, (key) => this.$t(key));
    },
    posterUrl() {
      const urls = getConceptCardImageUrls(this.card);
      return urls[0] || '';
    },
    posterIndex() {
      return getConceptCardPosterIndex(this.card);
    },
    outputBody() {
      return getCardOutputBody(this.card);
    },
    metaFields() {
      return getDetailBodyMetaFields(this.card, this.projectType, (key) => this.$t(key));
    },
  },
  methods: {
    onPosterDragStart(event, url, posterIndex) {
      this.startGhImageDrag(event, {
        url,
        itemType: this.card.item_type,
        posterIndex,
        sourceType: GH_DRAG_SOURCE.CONCEPT,
      });
    },
    onConceptTextDragStart(event) {
      this.startGhTextDrag(event, {
        text: this.outputBody,
        sourceType: GH_DRAG_SOURCE.CONCEPT,
        field: 'concept',
      });
    },
  },
};
</script>
